import ReCAPTCHA from "react-google-recaptcha"
import React, { useRef } from 'react'
import PropTypes from "prop-types"

/**
 * React GoogleRecaptchaComponent Component
 * @component
 * @example
 * const data = {
 *  googleRecaptchaV2SiteKey: key
 * }
 * return (
 * <GoogleRecaptchaComponent data={data}  />
 * )
 */
const GoogleRecaptchaComponent = ({
  data
}) => {
  const ref = useRef()

  // useEffect(() => {
  //   document.addEventListener('createCaptcha', async () => {
  //     const captcha = await ref?.current?.execute()
  //     const receiveCaptchaEvent = new CustomEvent("receiveCaptcha", {
  //       detail: captcha,
  //     })
  //     document.dispatchEvent(receiveCaptchaEvent)
  //   })
  // },[ref])

  return (
    <ReCAPTCHA
      ref={ref}
      size="invisible"
      sitekey={data.googleRecaptchaV2SiteKey}
    />
  )
}

GoogleRecaptchaComponent.propTypes = {
  data: PropTypes.object.isRequired,
}

export default GoogleRecaptchaComponent